import $ from '@vaersaagod/tools/Dom';

export default (el, props) => {
    const $el = $(el);
    const $html = $('html');
    const $image = $el.find('img');
    const $video = $el.find('video');
    const canPlayVideo = $html.hasClass('autoplay');
    let videoUrl = '';

    const loadVideo = () => {
        $video.attr('src', videoUrl);
    };

    const init = () => {
        if (canPlayVideo && props.videoUrl) {
            videoUrl = props.videoUrl;
            $image.css('display', 'none');
            //$image.addClass('lazyload');
            loadVideo();
        } else {
            $video.remove();
        }
    };

    const destroy = () => {

    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/VideoImage.js